import { render, staticRenderFns } from "./d-book-buy-button.vue?vue&type=template&id=ec06cb3c&"
import script from "./d-book-buy-button.vue?vue&type=script&lang=js&"
export * from "./d-book-buy-button.vue?vue&type=script&lang=js&"
import style0 from "./d-book-buy-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports